import { ComponentPropsWithoutRef } from 'react';

const PlusMinusIcon = ({
  height = 12,
  width = 20,
  ...rest
}: ComponentPropsWithoutRef<'svg'>) => (
  <svg viewBox="0 0 19.4 10.7" height={height} width={width} {...rest}>
    <path
      fill="#7FABEC"
      d="M8,5V3.3C8,3,7.8,2.8,7.5,2.8h-2V0.5C5.5,0.2,5.3,0,5,0H3C2.8,0,2.5,0.2,2.5,0.5v2.3h-2C0.2,2.8,0,3,0,3.3V5
	c0,0.3,0.2,0.5,0.5,0.5h2v2.3c0,0.3,0.2,0.5,0.5,0.5H5c0.3,0,0.5-0.2,0.5-0.5V5.5h2C7.8,5.5,8,5.3,8,5z"
    />
    <path
      fill="#7FABEC"
      d="M13.2,0.2C13.2,0.1,13,0,12.8,0h-1.3c-0.2,0-0.4,0.1-0.5,0.3l-3.3,9.7c-0.1,0.2,0,0.3,0.1,0.5
	c0.1,0.1,0.2,0.2,0.4,0.2h1.3c0.2,0,0.4-0.1,0.5-0.3l3.3-9.7C13.4,0.5,13.3,0.3,13.2,0.2z"
    />
    <path
      fill="#7FABEC"
      d="M18.8,5.5h-5.2c-0.3,0-0.5,0.2-0.5,0.5v1.7c0,0.3,0.2,0.5,0.5,0.5h5.2c0.3,0,0.5-0.2,0.5-0.5V6
	C19.3,5.7,19.1,5.5,18.8,5.5z"
    />
  </svg>
);

export default PlusMinusIcon;
